// @ts-nocheck
import { useContext } from 'react';
import { ConsentBannerUI } from '@/components/ui';
import {
  ConfigContext,
  PrivacySettingsContext,
  WidgetStateContext,
} from '@/context';
import { handleError } from '@/utils/error';

/**
 * @param {{
 *   zIndex: number;
 * }} props
 */
export function ConsentBanner({ zIndex }: { zIndex: number }) {
  const {
    toggleOpen,
    bannerClosed,
    setBannerClosed,
    open: privacyCenterOpen,
    consentManagementEnabled,
  } = useContext(WidgetStateContext);
  const {
    consentMode,
    doNotSellConsentEnabled,
    gpcSignal,
    privacySettingsSet,
    updatePrivacySettings,
  } = useContext(PrivacySettingsContext);

  const {
    bannerTheme,
    bannerEnabled,
    bannerLayout,
    bannerPosition,
    bannerTitleEnabled,
    bannerTitleText,
    bannerText,
    brandTheme,
    policyUrl,
    bannerLinkText,
    gcmEnabled,
    gcmPolicyUrl,
    gcmLinkText,
    closeButtonEnabled,
    acceptButtonText,
    denyButtonEnabled,
    denyButtonText,
    customizeButtonEnabled,
    customizeButtonText,
    doNotSellText,
    gpcText,
  } = useContext(ConfigContext);

  const addConsentEvents = async ({
    acceptAll,
    doNotSell,
  }: {
    acceptAll: boolean;
    doNotSell: boolean;
  }) => {
    try {
      updatePrivacySettings({ acceptAll, doNotSell, gpcSignal });
      setBannerClosed(true);
    } catch (err) {
      handleError(err);
    }
  };

  function showBanner() {
    if (!consentManagementEnabled) {
      return false;
    }
    if (!bannerEnabled) {
      return false;
    }
    if (consentMode === 'express') {
      return !privacySettingsSet && !bannerClosed;
    }
    if (consentMode === 'implied') {
      return !bannerClosed;
    }
    return false;
  }

  if (showBanner()) {
    return (
      <ConsentBannerUI
        {...{
          zIndex,
          privacyCenterOpen,
          bannerLayout,
          bannerTheme,
          bannerPosition,
          bannerTitleEnabled,
          bannerTitleText,
          bannerText,
          brandTheme,
          policyUrl,
          bannerLinkText,
          gcmEnabled,
          gcmPolicyUrl,
          gcmLinkText,
          customizeButtonEnabled,
          denyButtonEnabled,
          closeButtonEnabled,
          acceptButtonText,
          denyButtonText,
          customizeButtonText,
          onCustomizeClick: () => toggleOpen(),
          onFinishClick: addConsentEvents,
          doNotSellEnabled: doNotSellConsentEnabled,
          gpcSignal,
          doNotSellText,
          gpcText,
        }}
      />
    );
  }

  return <></>;
}
